module.exports = __webpack_public_path__ + "static/media/Sharp-LS018B7DH02-Mechanical-Drawing.ff05c258.jpg";